import Phaser from 'phaser';
import { GAME } from '../constants';
import { createNewRun } from '../run/RunState';
import { loadPixelFont } from '../ui/FontLoader';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  create(): void {
    const cx = GAME.WIDTH / 2;
    const cy = GAME.HEIGHT / 2;

    // Loading bar
    const barBg = this.add.rectangle(cx, cy, 300, 12, 0x0a0a14)
      .setStrokeStyle(1, 0x444466);
    const barFill = this.add.rectangle(cx - 148, cy, 4, 8, 0xffd166);

    const loadingText = this.add.text(cx, cy + 24, 'Loading...', {
      fontSize: '12px',
      fontFamily: 'monospace',
      color: '#9da6c7',
    }).setOrigin(0.5);

    // Animate loading bar while font loads
    this.tweens.add({
      targets: barFill,
      scaleX: 72,
      duration: 1200,
      ease: 'Sine.easeInOut',
    });

    loadPixelFont().then(() => {
      barFill.scaleX = 72;
      this.navigateToScene();
    }).catch(() => {
      // Font failed to load — continue with monospace fallback
      this.navigateToScene();
    });
  }

  private navigateToScene(): void {
    const sceneParam = new URLSearchParams(window.location.search).get('scene');
    if (sceneParam === 'map') {
      this.scene.start('MapScene', { run: createNewRun(1337) });
      return;
    }
    if (sceneParam === 'combat') {
      this.scene.start('CombatScene', { run: createNewRun(1337), nodeType: 'combat' });
      return;
    }
    this.scene.start('MainMenuScene');
  }
}
